import * as AuthHelper from './authHelper'

export const startCandidateContact = (/* candidateId: number */): void => {
  // TODO
}

export default {
  AuthHelper
}
